import * as languageJsonFile from 'src/assets/languages/default.json';
import * as _ from 'lodash';

/**
 * Pure standalone language term resolver. This is the single source of truth
 * for resolving localised terms from the build-time language file.
 *
 * Both UtilsService (for template usage) and plain model classes (SiteModel,
 * etc.) import from this file. Keeping it separate from UtilsService avoids
 * circular dependency risks between the service layer and the data layer.
 *
 * @param path Dot-notation path into the language file (e.g. 'sites.emergency-evacuation-plan.labels.worksafe-phone')
 * @param defaultValue Fallback value if the path is not found in the language file
 */
export function getLangTerm(path: string, defaultValue: any): any {
  return _.get(languageJsonFile, 'default.' + path, defaultValue);
}
